import RunnerPauseButton from './RunnerPauseButton'

export default function RunnerUIFooterRight() {
  const isTouch = 'ontouchstart' in window

  if (isTouch) return null

  return (
    <div className={`flex flex-col gap-16 w-full items-end`}>
      <RunnerPauseButton />
    </div>
  )
}
